// AppContainer.js
import React, { useEffect, useRef } from "react";

const AppContainer = ({ children }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Hàm này sẽ tính toán và áp dụng tỷ lệ co giãn
    const handleResize = () => {
      if (containerRef.current) {
        // Lấy chiều rộng hiện tại của cửa sổ trình duyệt
        const currentWidth = window.innerWidth;

        // Tính toán tỷ lệ dựa trên kích thước 1920px
        const scale = currentWidth / 1920;

        // Áp dụng tỷ lệ co giãn cho container
        containerRef.current.style.transform = `scale(${scale})`;
      }
    };

    // Lắng nghe sự kiện thay đổi kích thước cửa sổ
    window.addEventListener("resize", handleResize);

    // Gọi hàm lần đầu để thiết lập tỷ lệ ban đầu
    handleResize();

    // Dọn dẹp sự kiện khi component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // [] đảm bảo hook chỉ chạy một lần

  return (
    <div ref={containerRef} className="app-container">
      {children}
    </div>
  );
};

export default AppContainer;
